module.exports = __webpack_public_path__ + "public/files/img/committees.14ef10ea.gif";